import React from "react";
import "../App.css";

// import {
//   BrowserRouter as Router,
//   Redirect,
//   Route,
//   Switch,
// } from 'react-router-dom';

const Home = () => (
  <>
    <section className={"effect-section theme-bg parallax container1"}>
      <div className={"container"}>
        {/*<FloatButton/>*/}
        <div
          className={
            "row full-screen align-items-left p-100px-tb justify-content-left"
          }
        >
          <div className={"col-lg-6 col-md-7 m-30px-tb"}>
            <h4 className={"display-4 m-20px-b white-color"}>
              Your company on any smartphone.
            </h4>
            <p className={"font-2 white-color"}>
              Adapt your business to digital media. <br></br>Don't lose
              customers
            </p>
            <div className={"p-10px-t m-btn-wide"}>
              <a
                className={"m-btn m-btn-radius m-btn-quote m-10px-r"}
                href="/FormPrice"
              >
                <span className={"m-btn-inner-text"}>Free quotation</span>
              </a>
            </div>
          </div>
          {/* <div className={"col-md-6 text-center m-30px-tb"}>
    <img
      className={"max-width-140 resize-img"}
      src={require('../images/banners/banner3.png')}
      title="phone"
      alt="phone"
      loading={"lazy"}
      width={756}
      height={638}
    />
  </div> */}
        </div>
      </div>
    </section>
  </>
);

export default Home;
